// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sa-5";
export var filledCircle = "_sa-4";
export var historyEntry = "_sa-3";
export var messageSideLeft = "_sa-1";
export var messageSideRight = "_sa-2";
export var orderTrackingCarouselWrapper = "_sa-6";
export var orderTrackingInfoContainer = "_sa-0";